import React, { useMemo, useState } from 'react';
import Dialog from '@material-ui/core/Dialog/Dialog';

import Link from 'next/link';

import Button from '@gjc/classi-react-commons/ClassiButton';
import { MobileBottomBarContainer } from './mobileBottomBarAnuncio-styled';
import Fechado from '../LeadBox/Fechado';
import { DialogOpenContext } from './mobileBottomBarAnuncioContext';
import { whatsappUrlForSharingAdvertising } from 'utils/whatsappUrl';

const MobileBottomBarAnuncio = ({ anunciante, idAnuncio, tituloAnuncio }) => {
    const whatsappUrl = whatsappUrlForSharingAdvertising(
        anunciante?.whatsApp,
        tituloAnuncio
    );

    const [dialogOpen, setDialogOpen] = useState(false);
    const value = useMemo(() => ({ dialogOpen, setDialogOpen }), [dialogOpen]);

    return (
        <DialogOpenContext.Provider value={value}>
            <MobileBottomBarContainer>
                {anunciante?.whatsApp && (
                    <Link href={whatsappUrl} passHref>
                        <Button
                            label={'WhatsApp'}
                            appearance={'primary'}
                            type={'button'}
                            style={{
                                backgroundColor: '#25d366',
                                margin: 0,
                                border: 'solid 1px #25d366',
                                width: '50%',
                                height: '100%',
                                boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
                                borderRadius: 0,
                            }}
                        />
                    </Link>
                )}

                <Button
                    label={'Ver Contato'}
                    appearance={'primary'}
                    type={'button'}
                    onClick={() => setDialogOpen(true)}
                    style={{
                        backgroundColor: '#ffa000',
                        margin: 0,
                        border: 'solid 1px #ffa000',
                        width: anunciante?.whatsApp ? '50%' : '100%',
                        height: '100%',
                        boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
                        borderRadius: 0,
                    }}
                />
            </MobileBottomBarContainer>

            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                fullScreen={true}
            >
                <Fechado
                    anunciante={anunciante}
                    idAnuncio={idAnuncio}
                    onDialog={true}
                />
            </Dialog>
        </DialogOpenContext.Provider>
    );
};

export default MobileBottomBarAnuncio;
